import Vue from "vue";
// import store from "~/store";
import axios from "axios";
import VueAxios from "vue-axios";
const dev_mode = window.location.host === 'kriton.safecontrol.sofar'
window._log_ = (() => {
    if (dev_mode) {
        return console.log;
    } else return () => {
    };
})();
_log_("ON full-url....", window.location.href,window.Travel);
if (!window.Travel.auth||window.Travel.auth=='0') {
    let forceDb =window.Travel.forcedb
    // window.location.href.indexOf("dali") >= 0
    // forceDb = window.location.href.indexOf("dali") >= 0 ? "dali" : null;
    // forceDb = window.location.href.indexOf("dali") >= 0 ? "dali" : null;
    // alert('hello')
    _log_("jump overide url....", forceDb);
    if (forceDb) Vue.axios.defaults.params.forcedb = forceDb;
}

export default {};
